import React from "react";
import { countries } from "country-data";

const ProbersTableRow = props => (
  <tr>
    <td className="location">
      {props.data.name}{" "}
      {/* <strong>{`, ${countries[props.data.country_code].name}`}</strong> */}
      {countries[props.data.country_code].emoji}
    </td>
    {props.protoType !== "HTTP(S)" ? (
      <td className="total-time-chart">
        <div className="prober-row-wrapper">
          <i
            className="server"
            style={{
              width:
                props.data.timing.duration === null
                  ? 0
                  : `${(props.data.timing.duration / props.max) * 100}%`
            }}
          >
            {format(props.data.timing.duration)}
          </i>
        </div>
        <i className="padding">
          {format(sum(props.data.timing, props.protoType))}
        </i>
      </td>
    ) : (
      <td className="total-time-chart">
        <div className="prober-row-wrapper">
          <i
            className="connect"
            style={{
              width:
                props.data.timing.connect === null
                  ? 0
                  : `${(props.data.timing.connect / props.max) * 100}%`
            }}
          >
            {format(props.data.timing.connect)}
          </i>
          <i
            className="handshake"
            style={{
              width:
                props.data.timing.tls === null
                  ? 0
                  : `${(props.data.timing.tls / props.max) * 100}%`
            }}
          >
            {format(props.data.timing.tls)}
          </i>
          <i
            className="server"
            style={{
              width:
                props.data.timing.response === null
                  ? 0
                  : `${(props.data.timing.response / props.max) * 100}%`
            }}
          >
            {format(props.data.timing.response)}
          </i>
        </div>
        <i className="padding">
          {format(sum(props.data.timing, props.protoType))}
          {`, ${props.data.timing.failed} failed`}
        </i>
      </td>
    )}
  </tr>
);

const format = data => {
  if (data < 1000) {
    return `${data == null ? 0 : data} ms`;
  } else if (data > 1000) {
    return `${(data / 1000).toFixed(2)} s`;
  }
};

const sum = (data, proto) => {
  return proto !== "HTTP(S)"
    ? data.duration
    : data.connect + data.tls + data.response;
};

export default ProbersTableRow;
